import type { PermissionKey, PermissionMap, SystemRole } from '@/types/permission.types'

export function hasPermission(
  permissions: PermissionMap | undefined,
  key: PermissionKey,
): boolean {
  if (!permissions) return false
  return permissions[key] === true
}

export function isSuperAdmin(role: SystemRole): boolean {
  return role === 'super_admin'
}

/** Super Admin always has every permission regardless of map */
export function canAccess(
  role: SystemRole,
  permissions: PermissionMap | undefined,
  key: PermissionKey,
): boolean {
  if (isSuperAdmin(role)) return true
  return hasPermission(permissions, key)
}

